import axios from 'axios';

const fdaAPIKey = 'pqzjvzbIFqGre1MCelExztpHcngQFHa9YZBj0sDJ';
const fdaURL = `https://api.fda.gov/drug/event.json`;
// `?generic_name=whatevs`

function makeMutationsQuery(mutations) {
  return {
    query: `
        query example($mutations:[String]!) {
          viewer {
            currentVersion { text, publishDate },
            mutationsAnalysis(mutations: $mutations) {
              # Begin of mutationsAnalysis fragment
              validationResults {
                level,
                message
              },
              drugResistance {
                gene { name },
                drugScores {
                  drugClass { name },
                  drug { name, displayAbbr, fullName },
                  SIR,
                  score,
                  level,
                  text,
                  partialScores {
                    mutations {
                      text
                    },
                    score
                  }
                },
                mutationsByTypes {
                  mutationType,
                  mutations {
                    text
                  }
                }
                commentsByTypes {
                  commentType,
                  comments {
                    text
                  }
                }
              }
              # End of mutationsAnalysis fragment
            }
          }
        }
      `,
    variables: {
      mutations
    }
  };
}

function queryMutations(mutations) {
  return axios.post('https://hivdb.stanford.edu/graphql', makeMutationsQuery(mutations))
    .then(({ data }) => data.data.viewer);
}

function queryDrugNames(rawDrugName) {
  const drugName = rawDrugName.replace(/\/r$/, '');
  return axios.get(`${fdaURL}?api_key=${fdaAPIKey}&search=${drugName}`)
    .then(({ data }) => {
      return data.results.reduce((acc, res) => {
        return acc.concat(
          res.patient.drug.reduce((ac, drug) => {
            if (drug.openfda && drug.openfda.generic_name && drug.openfda.brand_name) {
              return ac.concat(drug.openfda.generic_name.reduce((a, name) => {
                if (name === drugName.toUpperCase()) {
                  return a.concat(drug.openfda.brand_name);
                }
                return a;
              }, []));
            }
            return ac;
          }, []));
      }, []);
    });
}

export {
  queryMutations,
  queryDrugNames
};



// WEBPACK FOOTER //
// ./src/utils/service.js